import React from 'react';
import TokenSwapComponent from '../../components/token-swap-component';

const TokenSwapPage = () => {
  return (
    <>
      <TokenSwapComponent />
    </>
  )
}

export default TokenSwapPage;
